module.exports = __webpack_public_path__ + "img/senegal.a287e44.webp";